import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tiktok",
  "use": "icon-tiktok-usage",
  "viewBox": "0 0 20 19",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 19\" id=\"icon-tiktok\"><path d=\"M15.131 2.977A4.516 4.516 0 0 1 14.012 0h-3.261v13.089a2.736 2.736 0 0 1-2.734 2.639 2.753 2.753 0 0 1-2.745-2.745c0-1.815 1.752-3.177 3.557-2.617V7.03C5.188 6.544 2 9.373 2 12.983 2 16.498 4.913 19 8.006 19a6.012 6.012 0 0 0 6.006-6.017v-6.64a7.758 7.758 0 0 0 4.54 1.458V4.539s-1.985.095-3.42-1.562Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol